export default __webpack_public_path__ + "static/Blind-angels-dazon-video-thumbnail-c6f2f5fa328fd948d971ce9f0a57ec0f.png";